module.exports = __webpack_public_path__ + "images/content-sports.06848a8445e8e1fd2742e6e502c7cc2a.svg";